














































































































































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader, IsActive, ButtonExport, AccordionFilters } from '@/components'
import { DataTable } from '@/components/table'
import { ModalUpdateDeviceUser, ModalCessationEmployee, FiltersEmployees } from '@/components/config'

// constatnts
import {
  getTextTypeOfContract,
  getTextWorkCategory,
  employeeInitConst,
  getTextDocumentType,
  getTextConcubineType,
  getTextWorkType,
  getTextCondition,
  getTextLaborRegimen,
  getTextBank,
  getTextPaymentFrecuency,
  getTextSctrPensionType,
  getTextRegimes,
  getTextTypeComission
} from '@/constants'
import { TYPE_RE_ENTRY } from '@/constants/cessationEmployee'

// utils
import { loading, alerts } from '@/utils'

// models
import { Paginator } from '@/models'
import {
  EmployeeModel,
  DeviceHasEmployee,
  ReasonForTerminationWorkModel,
  CessationHistoryModel,
  FilterEmployeeModel,
  IEmployee
} from '@/models/config'

// services
import { EmployeeService, ReasonForTerminationWorkService } from '@/services/config'

@Component({
  name: 'EmployeesIndex',
  components: {
    PageHeader,
    DataTable,
    IsActive,
    ModalUpdateDeviceUser,
    ModalCessationEmployee,
    FiltersEmployees,
    ButtonExport,
    AccordionFilters
  }
})
export default class EmployeesIndex extends Vue {
  title = 'Empleados'
  loading = false
  showFilters = true
  filters: FilterEmployeeModel = {
    name: '',
    position: null,
    workCategory: null,
    typeContract: null,
    headquarters: null,
    area: null,
    subArea: null,
    workType: null,
    status: true
  }

  showModalUpdateDevice = false
  showModalCessation = false
  userSelected: EmployeeModel = employeeInitConst
  employees: EmployeeModel[]|[] = []
  reasonsTerminationWork: ReasonForTerminationWorkModel[] = []
  typeCessation = 0
  cessationEdit: CessationHistoryModel|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Empleados',
      active: true
    }
  ]

  fields = [
    {
      key: 'uid',
      sortable: true,
      label: 'Código'
    },
    {
      key: 'name',
      sortable: true,
      label: 'Nombre Completo'
    },
    {
      key: 'document_number',
      sortable: true,
      label: 'DNI'
    },
    {
      key: 'assignment.position.name',
      sortable: true,
      label: 'Cargo'
    },
    {
      key: 'assignment.work_category',
      sortable: true,
      label: 'Categoría Ocupacional'
    },
    {
      key: 'assignment.type_of_contract',
      sortable: true,
      label: 'Tipo de Contrato'
    },
    {
      key: 'devices_text',
      sortable: true,
      label: 'Registrado en Disp.'
    },
    {
      key: 'status_text',
      sortable: true,
      label: 'Status'
    },
    {
      key: 'actions',
      sortable: false,
      label: '',
      thClass: 'one-line w-30',
      thStyle: {
        width: '6%'
      }
    }
  ]

  headersExcel = [
    { text: 'Código', value: 'code' },
    { text: 'Apellido Paterno', value: 'last_name' },
    { text: 'Apellido Materno', value: 'mothers_last_name' },
    { text: 'Nombres', value: 'name' },
    { text: 'Sexo', value: 'sex_text' },
    { text: 'Correo', value: 'email' },
    { text: 'Tipo de Documento', value: 'document_type' },
    { text: 'Número de Documento', value: 'document_number' },
    { text: 'Fecha de Nacimiento', value: 'date_birth' },
    { text: 'Fecha Inicio de Labores (Historico)', value: 'work_start_date' },
    { text: 'Fecha Inicio de Labores', value: 'last_start_date' },
    { text: 'Teléfono', value: 'phone_number' },
    { text: 'Teléfono de Referencia', value: 'phone_number_ref' },
    { text: 'Departamento', value: 'state' },
    { text: 'Provincia', value: 'city' },
    { text: 'Distrito', value: 'district' },
    { text: 'Dirección (Según documento de identidad)', value: 'document_address' },
    { text: 'Dirección Actual', value: 'current_address' },
    { text: 'Referencias de Dirección', value: 'ref_address' },
    { text: 'Persona de Confianza', value: 'trusted_person' },
    { text: 'Cónyugue o Concubino', value: 'concubine' },
    { text: 'Hijos', value: 'children' },
    { text: 'Centro de Costo', value: 'cost_center' },
    { text: 'Cargo', value: 'position' },
    { text: 'Sede', value: 'headquarter' },
    { text: 'Área', value: 'area' },
    { text: 'Sub Área', value: 'subArea' },
    { text: 'Tipo de Trabajo', value: 'workType' },
    { text: 'Categoría Ocupacional', value: 'workCategory' },
    { text: 'Tipo de Contrato', value: 'typeOfContract' },
    { text: 'Turno de Tabajo', value: 'workShift' },
    { text: 'Condición del Personal', value: 'condition' },
    { text: 'Régime Laboral', value: 'regimen' },
    { text: 'Refrigerio', value: 'lunch' },
    { text: 'Banco Remuneraciones', value: 'bank' },
    { text: 'Nº de Cuenta Remuneraciones', value: 'accountNumber' },
    { text: 'Asignación Familiar', value: 'familyAllowance' },
    { text: 'Banco CTS', value: 'bankCts' },
    { text: 'Nº Cuenta CTS', value: 'accountNumberCts' },
    { text: 'Bonificación Regular', value: 'regularBonus' },
    { text: 'Salario Básico', value: 'baseSalary' },
    { text: 'Frecuencia de Pago', value: 'paymentFrequency' },
    { text: 'Gratificaciones Oridinarias', value: 'ordinaryPerks' },
    // { text: 'Seguro de Vida', value: 'lifeInsurance' },
    { text: 'Renta de Quinta', value: 'rent' },
    { text: 'Derecho al Ambiente', value: 'rightEnvironment' },
    { text: 'Seguro Regular 9%', value: 'regularInsurance' },
    { text: 'Seguro Agrario', value: 'agriculturalInsurance' },
    { text: 'Vida Ley', value: 'sctrLife' },
    { text: 'Compañía de Seguros', value: 'nameInsuranceCompany' },
    { text: 'SCTR Salud', value: 'sctrHealth' },
    { text: 'EPS', value: 'eps' },
    { text: 'SCTR Pensión', value: 'sctrPension' },
    { text: 'Tipo de SCTR Pensión', value: 'typeSctrPension' },
    { text: 'Régimen Pensionario', value: 'onpOrAfp' },
    { text: 'CUSSP', value: 'cussp' },
    { text: 'AFP', value: 'afp' },
    { text: 'Tipo de Comisión', value: 'comisionType' },
    { text: 'Fecha de Inscripción', value: 'dateAfp' },
    { text: 'Nivel Académico', value: 'academicLevel' },
    { text: 'Títulos Obtenidos', value: 'titlesObtained' },
    { text: 'Status', value: 'statusText' }
  ]

  get itemsExcel () {
    return this.allEmployees.map(employee => {
      const cessation_entry = employee.cessation.filter(c => c.type === TYPE_RE_ENTRY)
      let last_start_date = employee.work_start_date
      if (employee.cessation.length > 1 && cessation_entry.length > 0 && employee.is_active) {
        last_start_date = cessation_entry[cessation_entry.length - 1].date
      }
      return {
        code: employee.uid,
        name: employee.name,
        last_name: employee.last_name,
        mothers_last_name: employee.mothers_last_name,
        sex_text: employee.sex_text,
        email: employee.email,
        document_type: getTextDocumentType(employee.document_type),
        document_number: employee.document_number,
        date_birth: employee.date_birth,
        work_start_date: employee.work_start_date,
        last_start_date: last_start_date,
        phone_number: employee.phone_number,
        phone_number_ref: employee.phone_number_ref,
        state: employee.state.name,
        city: employee.city.name,
        district: employee.district.name,
        document_address: employee.document_address,
        current_address: employee.current_address,
        ref_address: employee.ref_address,
        trusted_person: employee.trusted_person ? 'SI' : 'NO',
        concubine: getTextConcubineType(employee.concubine_type),
        children: employee.has_children ? 'SI' : 'NO',
        cost_center: employee.assignment.cost_center.name,
        position: employee.assignment.position.name,
        headquarter: employee.assignment.headquarter.name,
        area: employee.assignment.area.name,
        subArea: employee.assignment.sub_area.name,
        workType: getTextWorkType(employee.assignment.work_type),
        workCategory: getTextWorkCategory(employee.assignment.work_category),
        typeOfContract: getTextTypeOfContract(employee.assignment.type_of_contract),
        workShift: employee.assignment.work_shift.name,
        condition: getTextCondition(employee.assignment.condition),
        regimen: getTextLaborRegimen(employee.assignment.labor_regime),
        lunch: employee.assignment.lunch ? 'SI' : 'NO',
        bank: getTextBank(employee.finance.bank),
        accountNumber: employee.finance.account_number,
        familyAllowance: employee.finance.family_allowance,
        bankCts: getTextBank(employee.finance.bank_cts),
        accountNumberCts: employee.finance.account_number_cts,
        regularBonus: employee.finance.regular_bonus,
        baseSalary: employee.finance.base_salary,
        paymentFrequency: getTextPaymentFrecuency(employee.finance.payment_frequency),
        ordinaryPerks: employee.finance.ordinary_perks,
        lifeInsurance: employee.insurance.life_insurance ? 'SI' : 'NO',
        rent: employee.insurance.rent ? 'SI' : 'NO',
        rightEnvironment: employee.insurance.right_environment ? 'SI' : 'NO',
        regularInsurance: employee.insurance.regular_insurance ? 'SI' : 'NO',
        agriculturalInsurance: employee.insurance.agricultural_insurance ? 'SI' : 'NO',
        sctrLife: employee.insurance.sctr_life ? 'SI' : 'NO',
        nameInsuranceCompany: employee.insurance?.insuranceCompany ? employee.insurance.insuranceCompany.name : '',
        sctrHealth: employee.insurance.sctr_health ? 'SI' : 'NO',
        eps: employee.insurance.eps ? 'SI' : 'NO',
        sctrPension: employee.insurance.sctr_pension ? 'SI' : 'NO',
        typeSctrPension: getTextSctrPensionType(Number(employee.insurance.sctr_pension_description)),
        onpOrAfp: getTextRegimes(employee.insurance.type_regime),
        cussp: employee.insurance.cussp,
        afp: employee.insurance.afp_id ? employee.insurance.afp.name : '',
        comisionType: getTextTypeComission(employee.insurance.type_of_commission),
        dateAfp: employee.insurance.date_afp,
        academicLevel: employee.academic_level,
        titlesObtained: employee.titles_obtained,
        statusText: employee.status_text
      }
    })
  }

  allEmployees: IEmployee[] = []

  pagination: Paginator = {
      currentPage: 1,
      total: 0,
      count: 0,
      perPage: 10
  }

  created () {
   this.getEmployeessWithPagination()
   this.getReasonTerminationWork()
  }

  async getAllitems () {
    this.allEmployees = await EmployeeService.getAll()
  }

  async getReasonTerminationWork () {
    this.reasonsTerminationWork = await ReasonForTerminationWorkService.getActivated()
  }

  getWithFilters (filters: FilterEmployeeModel) {
    this.filters = {
      ...filters
    }
    this.getEmployeessWithPagination()
  }

  async getEmployeessWithPagination () {
      this.loading = true
      const response = await EmployeeService.getWithPagination(this.pagination.perPage, this.pagination.currentPage, this.filters)
      this.employees = response.objects
      this.pagination = response.pagination
      this.loading = false
  }

  changePage (page: number) {
    this.pagination.currentPage = page
    this.getEmployeessWithPagination()
  }

  changePerPage (perPage: number) {
    this.pagination.perPage = perPage
    this.pagination.currentPage = 1
    this.getEmployeessWithPagination()
  }

  getTextDevices (devices: DeviceHasEmployee[]): string {
    if (devices.length > 0) {
      let text = ''
      devices.forEach(device => {
        if (text !== '') {
          text += ' | ' + device.device.name
        } else {
          text = device.device.name
        }
      })
      return text
    }
    return 'N/A'
  }

  getTextWorkCategory (id: number|null): string {
    if (id) {
      return getTextWorkCategory(id)
    }
    return '-----'
  }

  getTextTypeOfContract (id: number|null): string {
    if (id) {
      return getTextTypeOfContract(id)
    }
    return '-----'
  }

 async deleteItem (item: EmployeeModel) {
    const msg = `Seguro que desea eliminar el empleado: ${item.name} ${item.last_name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await EmployeeService.delete(item.id)
      alerts.success()
      this.getEmployeessWithPagination()
      loading('hide')
    }
  }

  async changeStatusSuccess () {
    loading('show')
    if (!this.cessationEdit) {
      await EmployeeService.changeStatus(Number(this.userSelected?.id), this.typeCessation === 1)
    }
    this.showModalCessation = false
    this.cessationEdit = null
    this.userSelected = {
      ...employeeInitConst
    }
    this.getEmployeessWithPagination()
    loading('hide')
  }

  async changeStatus (item: EmployeeModel) {
    this.userSelected = item
    this.typeCessation = item.is_active ? 0 : 1
    this.showModalCessation = true
  }

  updateDateCessation (item: CessationHistoryModel) {
    this.typeCessation = 0
    this.cessationEdit = item
  }

  updateDateReEntry (item: CessationHistoryModel) {
    this.typeCessation = 1
    this.cessationEdit = item
  }

  updateDeviceUser (user: EmployeeModel) {
    this.userSelected = user
    this.showModalUpdateDevice = true
  }
}
